export default function Overlay({ show = false }) {
  return (
    <div
      className={`${
        !show ? 'hidden' : ''
      } fixed inset-0 bg-white opacity-90 z-[9998]`}
    ></div>
  );
}
